import { renderFoxmarkApp } from "./app";
import { mountHeroShader } from "./heroShader";
import "./styles.css";

const app = document.querySelector<HTMLDivElement>("#app");

if (!app) {
  throw new Error("Missing #app root");
}

app.innerHTML = renderFoxmarkApp(window.location.pathname);

void mountHeroShader();

const mobileNav = app.querySelector<HTMLDetailsElement>(".mobile-nav");

if (mobileNav) {
  mobileNav.querySelectorAll<HTMLAnchorElement>("a").forEach((link) => {
    link.addEventListener("click", () => {
      mobileNav.open = false;
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      mobileNav.open = false;
    }
  });

  document.addEventListener("click", (event) => {
    if (mobileNav.open && event.target instanceof Node && !mobileNav.contains(event.target)) {
      mobileNav.open = false;
    }
  });
}

const intakeRedirect = app.querySelector<HTMLAnchorElement>(
  "[data-intake-redirect][data-auto-redirect='true']"
);

if (intakeRedirect) {
  const delayMs = Number(intakeRedirect.dataset.delayMs || "5500");

  window.setTimeout(() => {
    window.location.assign(intakeRedirect.href);
  }, delayMs);
}
